import React, { useState } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import api from "../../../api";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { fetchBonus } from "./store/bonusSlice";

const AddBonus = ({ show, onClose, userId }) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleAddBonus = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("bonus_sheet", file);
    setLoading(true);

    try {
      const response = await api.post("/import-bonus", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status === 200) {
        toast.success(response.data.message);
        onClose();
        dispatch(fetchBonus());
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFile(null);
    setFileName("");
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>{userId ? "Edit Bonus" : "Add Bonus"}</Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleClose}
          style={{
            position: "absolute",
            right: "1rem",
            top: "1rem",
            background: "transparent",
            border: "none",
            fontSize: "1.25rem",
          }}
        >
          &times;
        </button>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="formFile" className="mb-4">
          <Form.Label style={{ fontWeight: "500", fontSize: "1rem" }}>Upload Bonus File</Form.Label>
          <Form.Control
            type="file"
            accept=".csv"
            onChange={handleFileUpload}
          />
          {fileName && <small className="text-muted mt-2">Selected File: {fileName}</small>}
        </Form.Group>
        
        <div className="d-flex justify-content-end mt-3">
          <Button
            variant="primary"
            onClick={handleAddBonus}
            disabled={!file || loading}
            style={{ minWidth: "150px" }} // Keep button width consistent
          >
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2" // Add margin to the right
              />
            )}
            {userId ? "Update Bonus" : "Add Bonus"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};


export default AddBonus
